import { render } from "./product-feature-single-big.vue?vue&type=template&id=562c29f1"
import script from "./product-feature-single-big.vue?vue&type=script&lang=js"
export * from "./product-feature-single-big.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__